import { useState } from 'react'

//Funciones comunes generales
import { LogErrors } from './../../utilities/LogErrors'
import { ValidateSqlInjection } from './../../utilities/BL/Security'
import { useLanguage } from './../../utilities/LanguageContext'

//Funciones personalizadas del proyecto
import { FormatDateTime } from './../../utilities/BL/Instructor/Results'


const SearchInput = ({ placeholder, customClassName = '', evaluations, goToResultItem, maxResultsToShow = 5 }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    const [showResults, setShowResults] = useState(false)
    const [searchResults, setSearchResults] = useState([])


    /**
     * Busca entre las evaluaciones de la página conservando la posición original de
     * cada una, ya que es el índice con el que se abre el detalle del resultado.
     *
     * @param {string} searchTerm - Texto capturado por el usuario.
     * @returns {Array} Coincidencias en la forma { evaluation, index }.
     */
    const GetSearchResults = (searchTerm) => {
        const lowerCaseSearchTerm = searchTerm.toLowerCase()

        const matchingItems = (evaluations ?? [])
            .map((evaluation, index) => ({ evaluation, index }))
            .filter(({ evaluation }) => (evaluation?.name ?? '').toLowerCase().includes(lowerCaseSearchTerm))

        // Limitar el número de resultados al máximo especificado
        return matchingItems.slice(0, maxResultsToShow)
    }

    /**
     * Maneja la lógica de la búsqueda cuando el usuario escribe.
     * @param {Event} e - Evento onChange del input.
     */
    const ToggleSearchResults = async (e) => {
        try {
            const searchTerm = e.target.value

            // Validar longitud mínima y evitar inyección SQL
            if (searchTerm.trim() && searchTerm.length > 2) {
                if (await ValidateSqlInjection(searchTerm)) {
                    setShowResults(false)
                } else {
                    setSearchResults(GetSearchResults(searchTerm))
                    setShowResults(true)
                }
            } else {
                setShowResults(false)
            }
        } catch (error) {
            await LogErrors('ToggleSearchResults - Results SearchInput', error)
        }
    }

    /**
     * Deshabilita la tecla Enter en el input de búsqueda.
     * @param {Event} e - Evento onKeyDown.
     */
    const DisableEnterKey = async (e) => {
        try {
            if (e.key === 'Enter') {
                e.preventDefault()
            }
        } catch (error) {
            await LogErrors('DisableEnterKey - Results SearchInput', error)
        }
    }


    return (
        <div className={customClassName}>
            <input type='search' placeholder={placeholder} className='SearchInput' onChange={ToggleSearchResults} onKeyDown={DisableEnterKey} />

            <ul id='SearchResults' className={`SearchResults ${showResults ? 'ShowSearchResults' : ''}`}>
                {searchResults && searchResults.length > 0 ? (
                    <>
                        <p className="SearchResults-Title">{translate('labels.search.suggestions')} Sugerencias para tu búsqueda</p>

                        {searchResults.map(({ evaluation, index }) => (
                            <li key={index} className="SearchResults-Item" onClick={() => goToResultItem(index)}>
                                <span className="SearchResults-Item-Container">
                                    <i className="bi bi-search"></i>
                                    <span className="SearchResults-Text">{evaluation.name}</span>
                                    <span className="SearchResults-Type">
                                        {evaluation?.lastRequest ? FormatDateTime(evaluation.lastRequest) : ''}
                                    </span>
                                </span>
                                <i className="bi bi-arrow-right"></i>
                            </li>
                        ))}
                    </>
                ) : (
                    <p className="SearchResults-Title">{translate('labels.search.noResults')} No hay resultados para esta búsqueda</p>
                )}
            </ul>
        </div>
    )
}

export { SearchInput };
